import { render, staticRenderFns } from "./rfq-order-summary.vue?vue&type=template&id=587fff2a&scoped=true"
import script from "./rfq-order-summary.vue?vue&type=script&lang=js"
export * from "./rfq-order-summary.vue?vue&type=script&lang=js"
import style0 from "./rfq-order-summary.vue?vue&type=style&index=0&id=587fff2a&prod&lang=scss"
import style1 from "./rfq-order-summary.vue?vue&type=style&index=1&id=587fff2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587fff2a",
  null
  
)

export default component.exports